class StickyBlogNav extends HTMLElement {
  constructor() {
    super();
    this._onScroll = this._onScroll.bind(this);
    this._header = document.querySelector('.header');
    this._placeholder = null;
    this._isFixed = false;
    this._offset = 0;
    this._triggerPoint = null;
    this._footer = document.querySelector('.shopify-section--footer');
  }

  connectedCallback() {
    if (!this._header) return;

    window.requestAnimationFrame(() => {
      // Wait a tiny bit for layout to settle
      setTimeout(() => {
        const rect = this.getBoundingClientRect();
        const navHeight = this.offsetHeight;

        this._triggerPoint = rect.top + window.scrollY - this._header.offsetHeight + this._offset;

        // Create and insert placeholder
        this._placeholder = document.createElement('div');
        this._placeholder.style.display = 'none';
        this._placeholder.style.height = `${navHeight}px`;
        this.parentNode.insertBefore(this._placeholder, this);

        // Start scroll listener
        window.addEventListener('scroll', this._onScroll, { passive: true });
        this._onScroll(); // Run once on load
      }, 50);
    });
  }

  _onScroll() {
    const scrollY = window.scrollY;

    // Activate sticky
    if (!this._isFixed && scrollY >= this._triggerPoint) {
      this.classList.add('is-fixed');
      this.classList.remove('is-hidden');
      this._placeholder.style.display = 'block';
      this._isFixed = true;
    }

    // Deactivate sticky
    if (this._isFixed && scrollY < this._triggerPoint) {
      this.classList.remove('is-fixed', 'is-hidden');
      this._placeholder.style.display = 'none';
      this._isFixed = false;
    }

    // Fade out when reaching footer
    if (this._isFixed && this._footer) {
      const navBottom = this.getBoundingClientRect().bottom;
      const footerTop = this._footer.getBoundingClientRect().top;

      if (navBottom >= footerTop) {
        this.classList.add('is-hidden');
      } else {
        this.classList.remove('is-hidden');
      }
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
  }
}

customElements.define('sticky-blog-nav', StickyBlogNav);
